/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from 'react';
// import { AImage, AImageProps, AImageAspectRatio } from "@marriott/mi-web-ui-kit";
import * as Styled from './OResults.styles';
import backgroundImage from './preview.png';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import clsx from 'clsx';
import { resolveChatPreviewImageUrl } from '../../utils/chatPreviewImageUrl';

export const OResultsComp = (props: any) => {
  const model = props.model || {};
  const { aImage } = model;

  const previewFromModel = useMemo(() => resolveChatPreviewImageUrl(aImage), [aImage]);

  const bgUrl =
    previewFromModel || (backgroundImage as any)?.src || (backgroundImage as any)?.default || backgroundImage;

  const backgroundStyle = {
    backgroundImage: `url('${bgUrl}')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    position: 'relative' as const,
    width: '100%',
  };

  return (
    <Styled.Wrapper>
      {/* <AImage
        src={image.assetPath}
        alt={image.altText}
        renditions={image.renditions}
        enableSmartCrop={image.enableSmartCrop}
        dynamic={image.dynamic}
        damPath={image.damPath}
        aspectRatio={AImageAspectRatio["16:9"]}
      /> */}
      <Styled.EmptyState style={backgroundStyle}>
        {bgUrl && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              borderRadius: 'inherit',
            }}
          />
        )}
        <div
          style={{
            position: 'relative',
            zIndex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        ></div>
      </Styled.EmptyState>
    </Styled.Wrapper>
  );
};

export const OResultsConfig = {
  emptyLabel: 'OResults',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-results`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OResults = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <Styled.ResultsWrapper
      data-testid="o-results-comp"
      data-component-name="o-results"
      id={componentId}
      className={clsx(styleclass, 'd-md-block', 'd-none')}
    >
      <EditableComponent config={OResultsConfig} {...props}>
        <OResultsComp {...props} />
      </EditableComponent>
    </Styled.ResultsWrapper>
  );
};
